<p>
  {{ exampleDate | bbDate : 'bbShort' : 'GMT-0700' : 'en-US' }}
</p>
